{
  "id": "001-006",
  "title": "Severing ties",
  "version": 0,
  "layout": {
    "tiles": {
      "0": {
        "0": {
          "id": "31fddfab",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "rotation": 3,
              "id": "e43aaf8e"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "68de9848"
            },
            {
              "type": "rotate",
              "id": "e45bd074"
            }
          ]
        },
        "1": {
          "id": "7debc40d",
          "type": "tile"
        },
        "2": {
          "id": "4d3d4d5c",
          "type": "tile"
        },
        "-1": {
          "id": "9a141161",
          "type": "tile"
        },
        "-2": {
          "id": "4278d79d",
          "type": "tile"
        }
      },
      "1": {
        "0": {
          "id": "07559685",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "rotation": 3,
              "id": "732a68a9"
            }
          ]
        },
        "1": {
          "id": "8472fea8",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "579e323e"
            }
          ],
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 1
                },
                {
                  "color": "#ff0000",
                  "direction": 0,
                  "toggled": true
                }
              ],
              "id": "7dad4af4"
            }
          ]
        },
        "-1": {
          "id": "ae9deac9",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "rotation": 3,
              "id": "3dca0442"
            }
          ]
        },
        "-2": {
          "id": "f62e3a1a",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "5cf75411"
            }
          ],
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 0
                },
                {
                  "color": "#0000ff",
                  "direction": 1,
                  "toggled": true
                }
              ],
              "id": "d8bc4263"
            }
          ]
        }
      },
      "-1": {
        "0": {
          "id": "9742e8a6",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "2b5cf6ac"
            }
          ],
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 2,
                  "toggled": true
                },
                {
                  "color": "#ff0000",
                  "direction": 3
                }
              ],
              "id": "e55b2e61"
            }
          ]
        },
        "1": {
          "id": "78e0360f",
          "type": "tile"
        },
        "2": {
          "id": "ff1eab33",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "d85956fe"
            }
          ],
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 5
                },
                {
                  "color": "#ff0000",
                  "direction": 4,
                  "toggled": true
                }
              ],
              "id": "6a0bcd4f"
            }
          ]
        },
        "-1": {
          "id": "55998903",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "0843c4b1"
            }
          ],
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 4
                },
                {
                  "color": "#0000ff",
                  "direction": 5,
                  "toggled": true
                }
              ],
              "id": "320b734c"
            }
          ]
        },
        "-2": {
          "id": "3f752831",
          "type": "tile"
        },
        "-3": {
          "id": "d8d75757",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "cac0a0ed"
            }
          ],
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 2
                },
                {
                  "color": "#0000ff",
                  "direction": 3,
                  "toggled": true
                }
              ],
              "id": "8aeb000e"
            }
          ]
        }
      }
    },
    "modifiers": [
      {
        "type": "move",
        "id": "192b1b35"
      }
    ]
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 0
    },
    {
      "type": "moves",
      "amount": 4
    }
  ]
}
